module.exports = __webpack_public_path__ + "static/media/24UHCHR13.a7e155b8.jpg";